// extracted by mini-css-extract-plugin
module.exports = {"summary":"CoachCareerBlock_summary__gKKcR","cell":"CoachCareerBlock_cell__Uilyt","label":"CoachCareerBlock_label__4t9Rb","value":"CoachCareerBlock_value__U95gs"};